import React, { useContext, useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';
import Login from './components/Login/Login';

import './App.css';
import { publicRoutes, userRoutes, reviewerRoutes } from "./routes";

function App() {
  const user = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(true);

  // useEffect(() => {
  //   if (user) {
  //     setIsLoading(false);
  //   }
  // }, [user]);

  // if (isLoading) {
  //   return <div></div>;
  // }

  const isReviewer = user && user.roles && user.roles.includes('REVIEWER');
  const isUser = user && user.roles && user.roles.includes('USER');
  
  return (
    <BrowserRouter>
      <Routes>
        {/* {!user && <Route path="/" element={<Login />} />} */}
        {userRoutes.map(({ path, Component }) => (
            <Route key={path} path={path} element={Component} exact />
          ))}
        {isReviewer &&
          reviewerRoutes.map(({ path, Component }) => (
            <Route key={path} path={path} element={Component} exact />
          ))}
        {publicRoutes.map(({ path, Component }) => (
          <Route key={path} path={path} element={Component} exact />
        ))}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
